import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { Table } from 'primeng/table';
import { ProgramTypesGUID } from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { PaymentBatchStatusDropDown } from '../../../models/payment-batch-status.model';
import { PaymentBatch } from '../../../models/payment-batch.model';
import { PaymentScheduleEngagements } from '../../../models/payment-schedule-engagements.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { PaymentScheduleService } from '../../services/payment-schedule.service';

@Component({
  selector: 'app-new-payment-batch',
  templateUrl: './new-payment-batch.component.html',
  styleUrls: ['./new-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class NewPaymentBatchComponent implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;

  programTypeGuid: ProgramTypesGUID | any;
  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  engagementList: PaymentScheduleEngagements[] = [];
  paymentBatchStatus: PaymentBatchStatusDropDown[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  paymentBatchForm!: FormGroup;
  createPaymentBatch!: PaymentBatch;
  selectedEngagements: PaymentScheduleEngagements[] = [];
  clonedEngs: Record<number, PaymentScheduleEngagements> = {};
  editing = false;
  editingNav = false;
  isSpin = false;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';
  showForm = true;
  disableSubmit = false;
  firstEditInitEng!: PaymentScheduleEngagements;
  editRowsCtr = 0;
  programTypeId: any | null = null;
  selectedProgramOption!: string;

  constructor(
    private pmService: PaymentScheduleService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    public settings: SettingsService,
    public router: Router,
    public route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.programTypeId = this.route.snapshot.queryParamMap.get('program');
    this.selectedProgramOption = this.getSelectedProgramOptionByProgramTypeGuid(
      this.programTypeId
    );
    this.loading = true;
    this.editing = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.programTypeGuid = history.state.programTypeGuid;

    this.engcols = [
      { field: 'engagementID', header: 'Engagement ID' },
      { field: 'engagementName', header: 'Engagement Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'payeeID', header: 'Payee ID' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerID', header: 'Partner ID' },
      { field: 'paymentProfileStatus', header: 'ProfileStatus' },

      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },

      { field: 'payeeName', header: 'Payee Name' },
      { field: 'contactName', header: 'Contact Name' },
      { field: 'contactEmail', header: 'Contact Email' },
      { field: 'emailLanguage', header: 'Email Language' },
      { field: 'accountCode', header: 'Account Code' },
      {
        field: 'internalOrderOrCostCenter',
        header: 'Internal Order or Cost Center'
      },
      { field: 'currency', header: 'Currency' },
      { field: 'amount', header: 'Amount' },
      { field: 'taxAmount', header: 'Tax Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.paymentBatchForm = this.formBuilder.group({
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      amount: [''],
      partnerID: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: ['']
    });

    this.getEngagementDetials();
    this.getPaymentBatchStatus();
  }

  cancelSearchNav() {
    if (this.programTypeId == null) {
      this.router.navigate(['payment-schedule']);
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          selectedProgramOption: this.selectedProgramOption,
          program: this.programTypeId
        }
      };

      this.router.navigate(['events-payment-schedule'], navigationExtras);
    }
  }
  selectRow(e, l) {
    const engagementList = this.engagementList.find(
      item => item.engagementID === l.engagementID
    );

    if (engagementList) {
      if (e === true) {
        engagementList.editCheckBox = true;
      } else {
        engagementList.editCheckBox = false;
      }
    }
  }

  getEngagementDetials() {
    this.pmService
      .getPaymentScheduleEngagementDetials(
        this.settings.AliasName || '',
        this.programTypeId
      )
      .subscribe(engList => {
        this.engagementList = engList;
        this.totalRecords = this.engagementList.length;
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
        this.loading = false;
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'engagementID';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (this.engagementList === null || this.engagementList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.engagementList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
  getPaymentBatchStatus() {
    this.pmService.getPaymentBatchStatus().subscribe(engList => {
      this.paymentBatchStatus = engList;
    });
  }

  onSubmit() {
    this.loading = true;
    const datePipe = new DatePipe('en-US');

    this.createPaymentBatch = {
      paymentBatchScheduleDate:
        datePipe.transform(
          this.paymentBatchForm.controls['paymentBatchScheduleDate'].value,
          'MM/dd/yyyy'
        ) || '',
      anticipatedPaymentDate:
        datePipe.transform(
          this.paymentBatchForm.controls['anticipatedPaymentDate'].value,
          'MM/dd/yyyy'
        ) || '',
      actualPaymentCentralDate: this.paymentBatchForm.controls[
        'actualPaymentCentralDate'
      ].value
        ? datePipe.transform(
            this.paymentBatchForm.controls['actualPaymentCentralDate'].value,
            'MM/dd/yyyy'
          ) || ''
        : '',
      oDimEngagementPaymentBatchStatusId:
        this.paymentBatchForm.controls['paymentBatchStatus'].value
          .oDimEngagementPaymentBatchStatusId,
      userid: this.settings.AliasName || '',
      udtPaymentSchedule: []
    } as any;

    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined
    ) {
      for (const item of this.selectedEngagements) {
        this.createPaymentBatch.udtPaymentSchedule?.push({
          requestDetailId: item.engagementID,
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          partnerId: item.partnerID,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoiceDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID
        });
        const mn = this.engagementList.find(
          it => it.engagementID === item.engagementID
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.engagementID);
        }
      }
    }
    if (this.selectedEngagements.length === 0) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Engagement from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    this.createPaymentBatch.editids = this.selectedEngagements
      .filter(e => e.edited === true)
      .map(e => e.engagementID)
      .toString();

    if (this.programTypeId != null) {
      this.createPaymentBatch.paymentBatchScheduleDate = this.formatDate(
        this.createPaymentBatch.paymentBatchScheduleDate || ''
      );
      this.createPaymentBatch.anticipatedPaymentDate = this.formatDate(
        this.createPaymentBatch.anticipatedPaymentDate || ''
      );
      this.createPaymentBatch.actualPaymentCentralDate = this.createPaymentBatch
        .actualPaymentCentralDate
        ? this.formatDate(this.createPaymentBatch.actualPaymentCentralDate)
        : null;
    }
    this.pmService
      .createPaymentBatch(this.createPaymentBatch, this.programTypeId)
      .subscribe(
        messageResponse => {
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.selectedEngagements = [];
            this.paymentBatchForm.reset();
            this.msgs = [];
            this.msgs.push({
              severity: 'success',
              detail: 'Payment Batch Created Successfully'
            });
            setTimeout(() => {
              if (this.programTypeId == null) {
                this.router.navigate(['payment-schedule']);
              } else {
                const navigationExtras: NavigationExtras = {
                  state: {
                    selectedProgramOption: this.selectedProgramOption,
                    program: this.programTypeId
                  }
                };
                this.router.navigate(
                  ['events-payment-schedule'],
                  navigationExtras
                );
              }
            }, 2000);
            this.loading = false;
          } else if (this.apires.success === false) {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: this.apires.errorMessages
                ? this.apires.errorMessages[0]
                : 'An error occurred'
            });
          }
          this.showForm = false;
        },
        error => {
          this.loading = false;
          this.msgs = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Creating Payment Batch'
            });
          }
          this.showForm = true;
        }
      );
  }

  formatDate(inputDate: string): string {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onRowEditInit(eng: PaymentScheduleEngagements) {
    this.clonedEngs[eng.engagementID || -1] = { ...eng };
    this.disableSubmit = true;
    if (this.editRowsCtr === 0) {
      this.editing = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
  }

  onRowEditSave(eng: PaymentScheduleEngagements) {
    if (eng.amount !== null) {
      delete this.clonedEngs[eng.engagementID || -1];
      this.disableSubmit = false;
      eng.edited = true;
      eng.partnerID = this.firstEditInitEng.partnerID;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
    }

    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  onRowEditCancel(eng: PaymentScheduleEngagements, index: number) {
    this.engagementList[index] = this.clonedEngs[eng.engagementID || -1];
    delete this.clonedEngs[eng.engagementID || -1];
    const idx = this.selectedEngagements.findIndex(
      e => e.engagementID === eng.engagementID
    );
    this.selectedEngagements.splice(idx, 1);
    this.engagementList[index].editCheckBox = false;
    this.disableSubmit = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  getSelectedProgramOptionByProgramTypeGuid(
    ProgramType: ProgramTypesGUID
  ): string {
    this.programTypeId = ProgramType;
    let selectedProgramOption = 'Events';
    switch (ProgramType) {
      case ProgramTypesGUID.MRPP:
        selectedProgramOption = 'MRPP';
        break;
      case ProgramTypesGUID.Events:
        selectedProgramOption = 'Events';
        break;
      case ProgramTypesGUID.MSSP:
        selectedProgramOption = 'CSI';
        break;
    }
    return selectedProgramOption;
  }
}
